import qs from 'qs'
import request, { ResultHandler } from '@/core/utils/request'
const StackBaseUrl = '/business/stack'
export async function queryStackSlots(params) {
  const result = await request({
    url: StackBaseUrl,
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Query stack slots failed!') ?? null
}

export function parseStackNo(no) {
  const len = no.length
  const res = {}
  if (len >= 3) {
    res.rowNo = no.slice(0, 3).toUpperCase()
  }
  if (len >= 4) {
    res.stackNo = no[3].toUpperCase()
  }
  if (len >= 6) {
    res.sectionNo = no.slice(4, 6).toUpperCase()
  }
  if (len === 7) {
    res.slotNo = no[6].toUpperCase()
  }
  return res
}

export function filterSlot(slot, filters) {
  for (const key in filters) {
    if (slot[key] !== filters[key]) return false
  }
  return true
}

export function calcLoadRate(slots) {
  if (slots.length === 0) return 0
  const filledSlots = slots.filter(
    slot => slot.pallet !== undefined && slot.pallet !== null
  )
  return Number((filledSlots.length / slots.length).toFixed(1))
}

export const createStack = async stack => {
  const result = await request({
    url: StackBaseUrl,
    method: 'POST',
    data: stack
  })
  return ResultHandler(result, 'Create stack failed!')
}

export const editStack = async stack => {
  const result = await request({
    url: StackBaseUrl,
    method: 'PUT',
    data: stack
  })
  return ResultHandler(result, 'Edit stack failed!')
}

export const searchStacks = async params => {
  const result = await request({
    url: StackBaseUrl,
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Query stack failed!')?.list ?? []
}

export const removeStack = async stackId => {
  const result = await request({
    url: StackBaseUrl + '/' + stackId,
    method: 'DELETE'
  })
  return ResultHandler(result, 'Delete stack failed!')
}

export async function labelStack(stackNo) {
  const result = await request({
    url: StackBaseUrl + `/${stackNo}/label`,
    method: 'GET',
    responseType: 'blob'
  })
  return result
}
